/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedEmployeeTypeDropdown200,
  GetApiV1PersonSharedEmployeeTypeDropdown401,
  GetApiV1PersonSharedEmployeeTypeDropdown500,
  GetApiV1PersonSharedEmployeeTypeDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedEmployeeTypeDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedEmployeeTypeDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedEmployeeTypeDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedEmployeeTypeDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedEmployeeTypeDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedEmployeeTypeDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedEmployeeTypeDropdown500>;

export const getApiV1PersonSharedEmployeeTypeDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedEmployeeTypeDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedEmployeeTypeDropdownQueryResponse>;
